import * as React from 'react';

export const CreateFeed = React.lazy(() => import('./CreateFeed'));
